import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {PitNavigatorComponent} from "./ui/components/pit-navigator/pit-navigator.component";
import {DxAuthGuard} from "../dx-auth/services/dx-auth-guard";


const routes: Routes = [
  {
    path: 'navigator',
    pathMatch: 'prefix',
    component: PitNavigatorComponent,
    canActivate: [DxAuthGuard],
    children: [
      {path: '', redirectTo: 'tasks', pathMatch: 'full'}, // Пока принудительно редиректим на задачи
      {path: 'tasks', loadChildren: () => import('../bdpk-tasks/bdpk-tasks.module').then(mod => mod.BdpkTasksModule) },
/*
      {path: 'administration', loadChildren: () => import('../pit-administration/pit-administration.module').then(mod => mod.PitAdministrationModule)},
      {path: 'agreement', loadChildren: () => import('../pit-agreement/pit-agreement.module').then(mod => mod.PitAgreementModule)},
      {path: 'contracts', loadChildren: () => import('../pit-contracts/pit-contracts.module').then(mod => mod.PitContractsModule)},
      {path: 'it-activities', loadChildren: () => import('../pit-activities/pit-activities.module').then(mod => mod.PitActivitiesModule)},
      {path: 'home', loadChildren: () => import('../pit-home/pit-home.module').then(mod => mod.PitHomeModule)},
      {path: 'nci', loadChildren: () => import('../pit-nci/pit-nci.module').then(mod => mod.PitNciModule)},
      {path: 'planning', loadChildren: () => import('../pit-planning/pit-planning.module').then(mod => mod.PitPlanningModule)},
      {path: 'procurements', loadChildren: () => import('../pit-purchases/pit-purchases.module').then(mod => mod.PitPurchasesModule)},
      {path: 'reporting', loadChildren: () => import('../pit-reporting/pit-reporting.module').then(mod => mod.PitReportingModule)},
      {path: 'dashboard', loadChildren: () => import('../pit-dashboard/pit-dashboard.module').then(mod => mod.PitDashboardModule)}
*/
    ]
  },
];


/**
 * Модуль декларирует внутренний роутинг в `PitNavigationModule`.
 *
 * Что какается отложенной загрузки модулей при помощи конструкции:
 * ```
 * loadChildren: '<относительный путь до ts-файла модуля>#<имя класса модуля>'
 * ```
 * Да неудобно, но другого пути нет. Конструкция с лямда выражением:
 * ```
 * loadChildren () => PitHomeModule
 * ```
 * не работает. Заморочки с AOT-компиляцией.
 *
 * Также работает конструкция:
 * ```
 * export function getPitHomeModule(): any { return PitHomeModule; }
 * loadChildren: getPitHomeModule
 * ```
 * Ее и будем использовать, как наболее удобную с точки зрения рефакторинга.
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PitNavigationRoutingModule { }
